// extracted by mini-css-extract-plugin
module.exports = {"root":"_1617b1","text":"_1f1c86","logo":"_2b9b64"};